/**
 * Created by intellicar-rinas on 22/12/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './DialFlatView.css';
import Dom from '../../../../helpers/Dom';

class DialFlatView extends Component {

    constructor(){
        super();

        this.getV = () => {
            return this.props.vehicle && this.props.vehicle.stats ? this.props.vehicle : {
                stats:{},
                vehiclemeta:{},
            }
        };

        this.updateView = () => {
            this.forceUpdate();
        };

        this.isStateAvail = key => {
            return key in this.getV().stats && this.getV().stats[key] !== 'NA';
        };

    }

    render() {
        return (
            <div className='DialFlatView'>
                <div className="dfv-vset">
                    <div className="dfv-vehicleno">{this.getV().vehicleno}</div>
                    <div className="dfv-model">{this.getV().vehiclemeta.model}</div>
                    <div className="dfv-transmission">{this.getV().vehiclemeta.transmission}</div>
                    <div className="dfv-fueltype">{this.getV().vehiclemeta.fueltype}</div>
                </div>
                <div className="dfv-iconset">
                    <div className={Dom.Class({'active':this.isStateAvail('ac'), 'yellow':this.getV().stats.ac > 0},"dfvi-item")}>AC</div>
                    <div className={Dom.Class({'active':this.isStateAvail('parkingbreak'), 'yellow':this.getV().stats.parkingbreak > 0},"dfvi-item")}>P</div>
                    <div className={Dom.Class({'active':this.isStateAvail('mil'), 'red':this.getV().stats.mil > 0},"dfvi-item")}>M</div>
                    <div className={Dom.Class({'active':this.isStateAvail('indicator'), 'yellow':this.getV().stats.indicator > 0},"dfvi-item")}>I</div>
                    <div className={Dom.Class({'active':this.isStateAvail('seatbelt'), 'red':this.getV().stats.seatbelt < 1, 'yellow':this.getV().stats.seatbelt > 0},"dfvi-item")}>SB</div>
                    <div className={Dom.Class({'active':this.isStateAvail('headlight'), 'yellow':this.getV().stats.headlight > 0},"dfvi-item")}>HL</div>
                    <div className={Dom.Class({'active':this.isStateAvail('mobilistatus'), 'red':this.getV().stats.mobilistatus > 0},"dfvi-item")}>IM</div>
                    <div className={Dom.Class({'active':this.isStateAvail('lock'), 'yellow':this.getV().stats.lock > 0},"dfvi-item")}>LC</div>
                </div>
                <div className="dfv-bar">
                    <div className="dfvb-item">
                        <span className="dfvbi-head">Speed</span> : <span className="dfvbi-data">{this.getV().stats.speed}</span> Kmph
                        <div className="dfvbi-progress" style={{width:(this.getV().stats.speed/200*100)+'%'}}></div>
                    </div>
                    <div className="dfvb-item pink">
                        <span className="dfvbi-head">RPM</span> : <span className="dfvbi-data">{this.getV().stats.rpm}</span> rpm
                        <div className="dfvbi-progress" style={{width:(this.getV().stats.rpm/7000*100)+'%'}}></div>
                    </div>
                    <div className="dfvb-item blue">
                        <span className="dfvbi-head">Engine Temp</span> : <span className="dfvbi-data">{this.getV().stats.enginetemp}</span> c
                        <div className="dfvbi-progress" style={{width:(this.getV().stats.enginetemp/120*100)+'%'}}></div>
                    </div>
                    <div className="dfvb-item yellow">
                        <span className="dfvbi-head">Fuel Level</span> : <span className="dfvbi-data">{this.getV().stats.fuel}</span> %
                        <div className="dfvbi-progress" style={{width:(this.getV().stats.fuel)+'%'}}></div>
                    </div>
                </div>
            </div>
        )
    }

    componentWillReceiveProps(props){
        this.props = props;
    }

}

const mapPropsToState = state => {
    return {}
}

export default DialFlatView;